/**
 * Single source of truth for prices, in euro.
 *
 * The shop reads these for display and the payment service reads the same
 * values to charge — nothing a browser sends is trusted. Keyed by product
 * name, which is what the cart stores.
 *
 * The N1 is missing on purpose: it is quoted, not sold through the cart (see
 * config/n1.js).
 */
export const PRICES = {
  Blackbox: 399,
  Donager: 1150,
  Aurora: 599,
};
